var map = {
	"./additionalInfoIcon.svg": 566,
	"./arrowLeftIcon.svg": 567,
	"./arrowMediumTop.svg": 568,
	"./arrowRightIcon.svg": 569,
	"./arrowRightIconSharp.svg": 570,
	"./arrowRightSmallIcon.svg": 571,
	"./arrowScalableIcon.svg": 572,
	"./arrowSelect2.svg": 573,
	"./arrowSelectIcon.svg": 574,
	"./benefit1.svg": 575,
	"./benefit2.svg": 576,
	"./benefit3.svg": 577,
	"./cardsIcon.svg": 578,
	"./crossIcon.svg": 579,
	"./crossIcon2.svg": 580,
	"./crossIcon3.svg": 581,
	"./crossIconSmall.svg": 582,
	"./crossSmallIcon.svg": 583,
	"./defaultCategoryIcon.svg": 584,
	"./depNumberIcon.svg": 585,
	"./elfCentralIcon.svg": 586,
	"./equalitySign.svg": 587,
	"./errorIcon.svg": 332,
	"./eyeClosedIcon.svg": 588,
	"./eyeOpenIcon.svg": 589,
	"./favoritesIcon.svg": 590,
	"./favoritesLabelIcon.svg": 591,
	"./filterDivider.svg": 592,
	"./filterIcon.svg": 593,
	"./frequencyIcon.svg": 594,
	"./fsAmountIcon.svg": 595,
	"./fullScreenIcon.svg": 596,
	"./gameIcon.svg": 597,
	"./hamburgerIcon.svg": 598,
	"./infoIcon.svg": 599,
	"./infoSymbol.svg": 600,
	"./levelBackground.svg": 601,
	"./levelBackgroundNew.svg": 602,
	"./lockIcon.svg": 603,
	"./maxBonusAmountIcon.svg": 604,
	"./maxWinFsIcon.svg": 605,
	"./menuIcon.svg": 606,
	"./minDepIcon.svg": 607,
	"./noTournamentIcon.svg": 608,
	"./playIcon.svg": 609,
	"./polygon.svg": 610,
	"./preloaderDotsAnimation.svg": 611,
	"./preloaderSpinnerAnimation.svg": 612,
	"./promoIcon.svg": 613,
	"./recentIcon.svg": 614,
	"./search2Icon.svg": 615,
	"./search3Icon.svg": 616,
	"./smallInfoSymbol.svg": 617,
	"./successIcon.svg": 618,
	"./supportIcon.svg": 619,
	"./tag1Icon.svg": 620,
	"./tag2Icon.svg": 621,
	"./tag3Icon.svg": 622,
	"./tag4Icon.svg": 623,
	"./tickIcon.svg": 624,
	"./unverified.svg": 625,
	"./verified.svg": 626,
	"./wagerIcon.svg": 627,
	"./wagerTimeIcon.svg": 628,
	"./warningIcon.svg": 629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 565;